import React from 'react';
import CombinedProviders from './CombinedProviders';
import RootRouter from './RootRouter';
import { StyledToastContainer } from '../helpers/toast';
import '../index.css';
import '../reset.css';
interface NexodataReceitasProps {
  routes: Array<{ path: string; component: React.FC | Promise<any> }>;
}

export default function NexodataReceitas(props: NexodataReceitasProps) {
  return (
    <div id="App">
      <CombinedProviders>
        <>
          <div id="modals"></div>
          <RootRouter routes={props.routes} />
          <StyledToastContainer />
        </>
      </CombinedProviders>
    </div>
  );
}
